<template>
	<div class="container">
		<NoticeNav/>
		<div class="clearfix"></div>
		<div class="notice-content" v-if="noticeList.length>0">
			<ul class="notice-list">
				<li v-for="item in noticeList" :key="item.id" @click="toDetail(item.id)">
					<p >{{item.title}}</p>
					<span>{{item.addTimeStr}}</span>
				</li>
			</ul>
		</div>
		<div v-else style="padding-bottom: 100px;">
			<ContentNo content="暂时没有公告"/>
		</div>
		<div class="page-size">
			<el-pagination
			background
			@current-change="handleCurrentChange"
			:page-size= this.pageSize
			layout="prev, pager, next"
			hide-on-single-page
			:total= this.total>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import NoticeNav from '@/components/NoticeNav'
import ContentNo from '@/components/contentno'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
  name: 'NoticeList',
  data(){
	return{
		activityId: '',
		noticeList: [],
		pageNum: 1,
		pageSize: 8,
		total: 0
	}
  },
  components: {
	NoticeNav,
	ContentNo
  },
  methods: {
	//获取公告列表
	async getNoticeList(){
		let url = 'v1/notice/list'
		let param = {
			activityId: this.activityId,
			pageNum: this.pageNum,
			pageSize: this.pageSize
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.noticeList = res.data.list
			this.total = res.data.total
		} else {
			this.$message.error(res.data.msg)
		}
	},
	handleCurrentChange(e){
		this.noticeList = []
		this.pageNum = e
		this.getNoticeList()
	},
	toDetail(id){
		this.$router.push(`/noticedetail/${id}`)
	},
	async getActiveInfo(){
		let url = 'v1/activity/getIndexActivity'
		let param = {}
		const res = await post(url, param)
		if(res.data.code==200) {
			let entity = res.data.entity
			this.activeInfo = entity
			localStorage.setItem('activityId', entity.id)
			localStorage.setItem('activityType', entity.activityType)
			localStorage.setItem('activeInfo', JSON.stringify(entity))
			this.activityId = entity.id
			this.getNoticeList()
		} else {
			this.$message.error(res.data.msg)
		}
	},
  },
  created(){
	window.scrollTo(0, 0)
	let activityId = localStorage.getItem('activityId')
	if(activityId){
		this.activityId = activityId
		this.getNoticeList()
	} else {
		this.getActiveInfo()
	}
  }
}
</script>

<style scoped>
	.container{
		width: 1028px;
		margin: 0 auto;
	}
	.notice-content{
		margin: 20px 0;
		min-height: 300px;
		padding:0 20px;
		box-sizing: border-box;
		background: #F7F7F7;
		font-size: 12px;
	}
	.notice-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 44px;
		border-bottom: 0.5px solid #BAB8B8;
		cursor: pointer;
	}
	.notice-list li:last-of-type{
		border-bottom: none;
	}
	.page-size{
		margin-bottom: 30px;
	}
</style>
